var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoveWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.08594 12.3052H2.81531C2.48379 12.3052 2.16584 12.1735 1.93142 11.9391C1.697 11.7046 1.56531 11.3867 1.56531 11.0552V3.55518C1.56531 3.22366 1.697 2.90571 1.93142 2.67129C2.16584 2.43687 2.48379 2.30518 2.81531 2.30518H6.71414M7.43469 11.2363V12.4656C7.43469 12.8459 7.56639 13.1043 7.80081 13.3348C8.03523 13.5654 8.35317 13.6949 8.68469 13.6949H14.1847C14.5162 13.6949 14.8342 13.5654 15.0686 13.3348C15.303 13.1043 15.4347 12.7916 15.4347 12.4656V5.08967C15.4347 4.76363 15.303 4.45095 15.0686 4.22041C14.8342 3.98987 14.5162 3.86035 14.1847 3.86035H8.68469C8.35317 3.86035 8.03523 3.98987 7.80081 4.22041C7.56639 4.45095 7.43469 4.76363 7.43469 5.08967V6.31898M11.1398 6.27765L13.6398 8.77765L11.1398 11.2776M4.13977 7.27765C4.13977 7.27765 5.13977 8.77765 7.38977 8.77765C9.63977 8.77765 13.1398 8.77765 13.1398 8.77765",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveWhite);
export default __webpack_public_path__ + "static/media/move-white.76df01dea0f9508ef96166068b86a1c9.svg";
export { ForwardRef as ReactComponent };